import { memo, useCallback } from 'react';
import { Button } from '@bonanza-social/moonlight';
import { Modal } from '@bonanza-social/navigation';
import LinkedBonanzaLogo from '../../LinkedBonanzaLogo';

import styles from './AuthHeader.module.css';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { openSocialRegistrationModal } from '@bonanza-social/registration/state';

function AuthHeader() {
  const dispatch = useDispatch();

  const onLoginPress = useCallback(() => {
    Modal.open({
      namespace: 'auth',
      type: 'Auth',
      options: {
        hideHeader: true,
      },
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
        paddingTop: 'space-200',
        backgroundColor: 'screenBackground',
      },
    });
  }, []);

  const onJoinPress = useCallback(() => {
    dispatch(openSocialRegistrationModal());
  }, [dispatch]);

  return (
    <div className={styles.authHeader}>
      <LinkedBonanzaLogo />
      <div className={styles.buttons}>
        <Button
          variant="secondary"
          onPress={onLoginPress}
          flex={1}
          locNS="auth"
          locKey="login"
          borderRadius="radius-full"
          overflow="hidden"
          alignSelf="center"
          borderColor="borderGoldSolid"
          borderWidth="border-width-025"
          labelProps={{
            variant: 'button-large',
            color: 'darkSurfaceAccentSolid',
            uppercase: true,
            animatedStyle: { letterSpacing: 1 },
          }}
        />
        <Button
          flex={1}
          variant="primary"
          onPress={onJoinPress}
          locNS="auth"
          locKey="join"
          borderRadius="radius-full"
          overflow="hidden"
          alignSelf="center"
          labelProps={{
            variant: 'button-large',
            uppercase: true,
            animatedStyle: { letterSpacing: 1 },
          }}
        />
      </div>
    </div>
  );
}

export default memo(AuthHeader);
